module.exports = __webpack_public_path__ + "./docs/img/scheme_4.bcc851f4c41fb8cab97291e43091665b.svg";